module.exports = __webpack_public_path__ + "static/media/400052_02.0db7b2fd.png";